import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import TextFieldInput from "../../../../components/TextFieldInput";
import { Box, Grid, Typography } from "@mui/material";
import CommonButton from "../../../../shared-components/common-button/CommonButton";
import { useDispatch, useSelector } from "react-redux";
import { route } from "../../../../services/apiRoutes";
import { useParams } from "react-router-dom";
import {
  formatNumberIndian,
  getErrorMessage,
  getLastStep,
} from "../../../../utilis/common-funtions";
import { REQUIRED_DOCS_FIELDS } from "../../../../config/constant";
import SnackbarAlert from "../../../../shared-components/snackbar-alert/SnackbarAlert";
import Loader from "../../../../components/Loader";
import { useTranslation } from "react-i18next";
import ReviewInput from "../../../../components/ReviewInput";
import UploadPopup from "../../../../shared-components/upload-popup/UploadPopup";
import ReferralDetails from "../ReferralDetails";
import {
  getBookingDocuments,
  setReviewActiveStep,
  setShowReferralModal,
  updateReviewDetails,
} from "../../new-booking-form.slice";

const UnitDetailStep = () => {
  const unitDetailsFormik = useFormik({
    initialValues: {
      projectName: "",
      carParkType: "",
      numOfCarPark: "",
      unitNumber: "",
      floor: "",
      blockTower: "",
      type: "",
      superBuiltArea: "",
      carpetArea: "",
      totalAgreementValue: "",
      primarySource: "",
      channel: "",
      bookingAmount: "",
      tdsPaid: "",
    },
  });

  const { t } = useTranslation();
  const [openPopup, setOpenPopup] = useState(null);
  const [fieldName, setFieldName] = useState("");
  const [snackbarConfig, setSnackBarconfig] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const dispatch = useDispatch();
  const { oppId } = useParams();

  const {
    enquiryDetails,
    activeStep,
    isLoading,
    applicantData,
    reviewActiveStep,
    projectBrandImage,
    showReferralModal,
    bookingDocuments,
  } = useSelector((state) => state?.newBookingForm);

  useEffect(() => {
    dispatch(getBookingDocuments(`/${oppId}`));
    window.scrollTo(0, 0);
  }, [dispatch, oppId]);

  const bookingDocConfig = REQUIRED_DOCS_FIELDS?.map((reqDoc) => {
    const documentsArray = Array.isArray(bookingDocuments) ? bookingDocuments : [];
    const foundDoc = documentsArray?.find((document) => document?.name === reqDoc.name);
    return {
      key: reqDoc.name.replace(/\s+/g, "").toLowerCase(),
      label: reqDoc.label,
      file: foundDoc?.path ? [foundDoc.path] : [], // empty array if missing
    };
  });

  useEffect(() => {
    if (enquiryDetails && enquiryDetails?.data) {
      let obj = {
        projectName:
          enquiryDetails?.data?.ProjectName !== null
            ? enquiryDetails?.data?.ProjectName
            : "N/A",
        carParkType:
          enquiryDetails?.data?.CarParkType !== null
            ? enquiryDetails?.data?.CarParkType
            : "N/A",
        numOfCarPark:
          enquiryDetails?.data?.No_Of_Carpark !== null
            ? enquiryDetails?.data?.No_Of_Carpark
            : "N/A",
        unitNumber:
          enquiryDetails?.data?.UnitNo !== null
            ? enquiryDetails?.data?.UnitNo
            : "N/A",
        floor:
          enquiryDetails?.data?.Floor !== null
            ? enquiryDetails?.data?.Floor
            : "N/A",
        blockTower:
          enquiryDetails?.data?.BlockTower !== null
            ? enquiryDetails?.data?.BlockTower
            : "N/A",
        type:
          enquiryDetails?.data?.unitType !== null
            ? enquiryDetails?.data?.unitType
            : "N/A",
        superBuiltArea:
          enquiryDetails?.data?.SuperBuiltupAreaSFt !== null
            ? formatNumberIndian(enquiryDetails?.data?.SuperBuiltupAreaSFt)
            : "N/A",
        carpetArea:
          enquiryDetails?.data?.Carpet_Area !== null
            ? formatNumberIndian(enquiryDetails?.data?.Carpet_Area)
            : "N/A",
        totalAgreementValue:
          enquiryDetails?.data?.TotalAgreementValue !== null
            ? formatNumberIndian(enquiryDetails?.data?.TotalAgreementValue)
            : "N/A",
        primarySource:
          enquiryDetails?.data?.primarySource !== null
            ? enquiryDetails?.data?.primarySource
            : "N/A",
        channel:
          enquiryDetails?.data?.referredbyChannelPartnerREAPName !== null
            ? enquiryDetails?.data?.referredbyChannelPartnerREAPName
            : "N/A",
        bookingAmount:
          enquiryDetails?.data?.BookingAmountAsPerAgreement !== null
            ? enquiryDetails?.data?.BookingAmountAsPerAgreement
            : "N/A",
      };
      unitDetailsFormik.setValues(obj);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enquiryDetails]);

  // Helper function to create the unit details payload
  const createUnitDetailsPayload = (saveForLaterFlag = false) => {
    return {
      opportunityId: oppId,
      lastStep: getLastStep(applicantData?.lastStep, activeStep),
      saveForLater: saveForLaterFlag,
      projectName:
        enquiryDetails?.data?.ProjectName !== null
          ? enquiryDetails?.data?.ProjectName
          : "",
      carParkType:
        enquiryDetails?.data?.CarParkType !== null
          ? enquiryDetails?.data?.CarParkType
          : "",
      numOfCarPark:
        enquiryDetails?.data?.No_Of_Carpark !== null
          ? enquiryDetails?.data?.No_Of_Carpark
          : "",
      unitNumber:
        enquiryDetails?.data?.UnitNo !== null
          ? enquiryDetails?.data?.UnitNo
          : "",
      floor:
        enquiryDetails?.data?.Floor !== null ? enquiryDetails?.data?.Floor : "",
      blockTower:
        enquiryDetails?.data?.BlockTower !== null
          ? enquiryDetails?.data?.BlockTower
          : "",
      type:
        enquiryDetails?.data?.unitType !== null
          ? enquiryDetails?.data?.unitType
          : "",
      superBuiltArea:
        enquiryDetails?.data?.SuperBuiltupAreaSFt !== null
          ? enquiryDetails?.data?.SuperBuiltupAreaSFt
          : "",
      carpetArea:
        enquiryDetails?.data?.Carpet_Area !== null
          ? enquiryDetails?.data?.Carpet_Area
          : "",
      totalAgreementValue:
        enquiryDetails?.data?.TotalAgreementValue !== null
          ? parseInt(enquiryDetails?.data?.TotalAgreementValue)
          : "",
      bookingAmount:
        enquiryDetails?.data?.BookingAmountAsPerAgreement !== null
          ? parseInt(enquiryDetails?.data?.BookingAmountAsPerAgreement)
          : "",
      primarySource:
        enquiryDetails?.data?.primarySource !== null
          ? enquiryDetails?.data?.primarySource
          : "",
      channel:
        enquiryDetails?.data?.referredbyChannelPartnerREAPName !== null
          ? enquiryDetails?.data?.referredbyChannelPartnerREAPName
          : "",
      unitDetailImage: projectBrandImage || "",
      projectBrandName: enquiryDetails?.data?.projectBrandName || "",
    };
  };

  const handleSaveForm = () => {
    const payload = createUnitDetailsPayload();

    dispatch(
      updateReviewDetails({
        path: route.UPDATE_UNIT_DATA,
        payload: payload,
        opportunityId: oppId,
      })
    )
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          setSnackBarconfig({
            open: true,
            message: t("unitDetails.messages.saveSuccess"),
            severity: "success",
          });

          dispatch(setShowReferralModal(true));
        }
      })
      .catch((error) => {
        setSnackBarconfig({
          open: true,
          message: getErrorMessage(error),
          severity: "error",
        });
      });
  };

  const handlePrevious = () => {
    dispatch(setReviewActiveStep(reviewActiveStep - 1));
  };

  const handleView = (name) => {
    setFieldName(name);
    setOpenPopup(true);
  };

  const handleSnackbarClose = () => {
    setSnackBarconfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <div className="applicantReviewCardContainer">
        <form onSubmit={unitDetailsFormik.handleSubmit} autoComplete="off">
          <Box sx={{ border: "1px dashed #DADADA", borderRadius: "8px", p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "projectName",
                    label: t("unitDetails.labels.projectName"),
                    placeholder: t("unitDetails.placeholder.projectName"),
                    required: false,
                    readonly: true,
                  }}
                  formik={unitDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "unitNumber",
                    label: t("unitDetails.labels.unitNumber"),
                    placeholder: t("unitDetails.placeholder.unitNumber"),
                    required: false,
                    readonly: true,
                  }}
                  formik={unitDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "blockTower",
                    label: t("unitDetails.labels.blockTower"),
                    placeholder: t("unitDetails.placeholder.blockTower"),
                    required: false,
                    readonly: true,
                  }}
                  formik={unitDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "floor",
                    label: t("unitDetails.labels.floor"),
                    placeholder: t("unitDetails.placeholder.floor"),
                    required: false,
                    readonly: true,
                  }}
                  formik={unitDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "type",
                    label: t("unitDetails.labels.type"),
                    placeholder: t("unitDetails.placeholder.type"),
                    required: false,
                    readonly: true,
                  }}
                  formik={unitDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "superBuiltArea",
                    label: t("unitDetails.labels.superBuiltArea"),
                    placeholder: t("unitDetails.placeholder.superBuiltArea"),
                    required: false,
                    readonly: true,
                  }}
                  formik={unitDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "carpetArea",
                    label: t("unitDetails.labels.carpetArea"),
                    placeholder: t("unitDetails.placeholder.carpetArea"),
                    required: false,
                    readonly: true,
                  }}
                  formik={unitDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "carParkType",
                    label: t("unitDetails.labels.carParkType"),
                    placeholder: t("unitDetails.placeholder.carParkType"),
                    required: false,
                    readonly: true,
                  }}
                  formik={unitDetailsFormik}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "numOfCarPark",
                    label: t("unitDetails.labels.numOfCarPark"),
                    placeholder: t("unitDetails.placeholder.numOfCarPark"),
                    required: false,
                    readonly: true,
                  }}
                  formik={unitDetailsFormik}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "totalAgreementValue",
                    label: t("unitDetails.labels.totalAgreementValue"),
                    placeholder: " ",
                    required: false,
                    readonly: true,
                  }}
                  formik={{
                    ...unitDetailsFormik,
                    values: {
                      ...unitDetailsFormik.values,
                      totalAgreementValue: unitDetailsFormik.values
                        .totalAgreementValue
                        ? `₹ ${unitDetailsFormik.values.totalAgreementValue}`
                        : "",
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextFieldInput
                  field={{
                    name: "bookingAmount",
                    label: t("unitDetails.labels.bookingAmount"),
                    placeholder: t("unitDetails.placeholder.bookingAmount"),
                    required: false,
                    readonly: true,
                  }}
                  formik={{
                    ...unitDetailsFormik,
                    values: {
                      ...unitDetailsFormik.values,
                      bookingAmount: unitDetailsFormik.values.bookingAmount
                        ? `₹ ${formatNumberIndian(
                            unitDetailsFormik.values.bookingAmount
                          )}`
                        : "",
                    },
                  }}
                />
              </Grid>
              {!applicantData?.primarySourceDisabled && (
                <Grid item xs={12} md={6}>
                  <TextFieldInput
                    field={{
                      name: "primarySource",
                      label: t("unitDetails.labels.primarySource"),
                      placeholder: t("unitDetails.placeholder.primarySource"),
                      required: false,
                      readonly: true,
                    }}
                    formik={unitDetailsFormik}
                  />
                </Grid>
              )}
              {!applicantData?.primarySourceDisabled &&
              unitDetailsFormik?.values?.primarySource === "Channel Partner" ? (
                <Grid item xs={12} md={6}>
                  <TextFieldInput
                    field={{
                      name: "channel",
                      label: t("unitDetails.labels.channel"),
                      placeholder: t("unitDetails.placeholder.channel"),
                      required: false,
                      readonly: true,
                    }}
                    formik={unitDetailsFormik}
                  />
                </Grid>
              ) : null}
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="body2"
                sx={{ color: "#344054", my: 2, textAlign: "justify" }}
              >
                {t("unitDetails.messages.helperText")}
              </Typography>
              <label
                className="checkTerms"
                style={{
                  marginTop: "8px",
                  display: "block",
                  fontSize: "12px",
                  color: "#212121",
                }}
              >
                {t("unitDetails.labels.tdsPaid")}
                <input
                  type="checkbox"
                  checked
                  onChange={(e) =>
                    unitDetailsFormik.setFieldValue("tdsPaid", e.target.checked)
                  }
                />
                <span className="checkmark"></span>
              </label>
            </Grid>
          </Box>

          <Box
            sx={{
              border: "1px dashed #DADADA",
              borderRadius: "8px",
              p: 2,
              mt: 4,
            }}
          >
            <Grid container spacing={2}>
              {bookingDocConfig?.map((doc) => (
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} key={doc?.key}>
                  <ReviewInput
                    text={doc?.label}
                    name={doc?.key}
                    onView={handleView}
                    disabled={!doc?.file?.length}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
          {openPopup && (
            <UploadPopup
              heading="View"
              totalImages={1}
              closePopup={() => setOpenPopup(false)}
              handleImageValue={() => {}}
              uploadedImage={
                unitDetailsFormik?.values[fieldName] ||
                bookingDocConfig?.find((d) => d?.key === fieldName)?.file ||
                []
              }
              fieldName={fieldName}
              handleUpdateImageData={() => {}}
              handlePhysicalImage={() => {}}
              selectedOptionValue={() => {}}
              fileType={""}
              hidePhysicalCopyOption
              dynamicSize={1}
              hideCameraOption={false}
              showDeleteIcon={false}
            />
          )}
          {showReferralModal ? <ReferralDetails /> : null}
          <CommonButton
            handleNext={handleSaveForm}
            handlePrevious={handlePrevious}
            saveDraftPath={route.UPDATE_UNIT_DATA}
            saveDraftData={createUnitDetailsPayload(true)}
          />
        </form>
      </div>
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default UnitDetailStep;
